module.exports = __webpack_public_path__ + "img/kns_logo@2x.dd290c78.png";